import { createSymbols } from 'utils/helpers';

const Types = createSymbols([
    'CREATE_REPORT',
    'FETCH_ALL_REPORTS',
    'FETCH_REPORT',
    'SET_REPORT',
    'UPDATE_REPORT',
    'UPDATE_REPORT_NAME',
    'DELETE_REPORT',
    'ADD_SEGMENT',
    'UPDATE_SEGMENT',
    'DELETE_SEGMENT',
    'ADD_PRODUCTS_TO_SEGMENT',
    // 'DELETE_PRODUCT_FROM_SEGMENT',
    'DELETE_PRODUCT',
    'SET_LOADER',
    'SELECT_PRODUCT_FOR_SEGMENT',
    'UNSELECT_PRODUCT_FOR_SEGMENT',
    'UPDATE_REPORT_LIST',
    'MOVE_PRODUCT_TO_SEGMENT'
]);

export default Types;
